import React from 'react';
import { Pencil } from 'lucide-react';
import {
  productMeta,
  PRODUCT_LOGO_BACKGROUNDS,
} from '../pages/admin/linksConfig.utils';
import { InfoTip, Toggle, ProductTileIcon } from './LinksConfigUi';

export default function LinksConfigProductsPanel({
  products,
  activeProductCount,
  toggleProduct,
  updateProductLabel,
}) {
  const hasOneMenuChannels = products.some((product) =>
    String(product.id).startsWith('onemenu_')
  );
  const visibleProducts = products.filter((product) => {
    const meta = { ...(productMeta(product.id) || {}), ...product };
    return !(meta.hiddenWhenUnavailable && product.available === false);
  });

  return (
    <section className="fsl-card">
      <div className="fsl-card-head">
        <h2 className="fsl-card-title">
          Produtos FoodStation
          <InfoTip text="Ative os produtos disponíveis e personalize o texto de cada botão." />
        </h2>
        <span className="fsl-count-chip">
          {activeProductCount}/{visibleProducts.length} ativos
        </span>
      </div>

      {hasOneMenuChannels && (
        <p className="fsl-product-channel-hint">
          No One Menu, escolha se o cliente será direcionado ao Delivery, ao Salão ou aos dois.
        </p>
      )}

      <div className="fsl-product-list">
        {visibleProducts.map((product) => {
          const meta = { ...(productMeta(product.id) || {}), ...product };
          const available = product.available !== false;
          if (!meta.icon && !meta.emoji) return null;

          return (
            <div
              key={product.id}
              className={`fsl-product-row ${product.enabled && available ? '' : 'is-off'} ${available ? '' : 'is-disabled'}`}
            >
              <div className="fsl-product-main">
                <div className="fsl-product-top">
                  <span className="fsl-product-name">
                    <span
                      className="fsl-product-name-logo"
                      style={{ backgroundColor: PRODUCT_LOGO_BACKGROUNDS[product.id] || '#fff' }}
                    >
                      <img
                        src={meta.icon}
                        alt=""
                        aria-hidden="true"
                        onError={(event) => {
                          event.currentTarget.style.display = 'none';
                        }}
                      />
                    </span>
                    {meta.product}
                  </span>
                  <InfoTip text={meta.description} />
                  {!available && (
                    <span className="fsl-product-access-chip">Sem acesso</span>
                  )}
                </div>

                <div className="fsl-product-edit">
                  <span className="fsl-product-inline-icon fsl-product-inline-icon--edit">
                    <ProductTileIcon id={product.id} />
                  </span>
                  <div className="fsl-product-input-wrap">
                    <Pencil size={13} strokeWidth={2.4} className="fsl-product-edit-icon" />
                    <input
                      className="fsl-mini-input"
                      value={product.label}
                      onChange={(event) => updateProductLabel(product.id, event.target.value)}
                      placeholder={meta.defaultLabel}
                      disabled={!product.enabled || !available}
                      maxLength={40}
                    />
                  </div>
                </div>
              </div>

              <Toggle
                checked={Boolean(product.enabled && available)}
                onChange={() => toggleProduct(product.id)}
                label={`Ativar ${meta.product}`}
                disabled={!available}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}

